import clsx from "clsx";
import { ReactNode } from "react";

import { SimCardDetailSimStatus } from "@/services/model";

export type ProductCardChipTone =
  | "success"
  | "warning"
  | "error"
  | "info"
  | "neutral";

const toneClassName: Record<ProductCardChipTone, string> = {
  success: "text-foreground-success",
  warning: "text-foreground-warning",
  error: "text-foreground-error",
  info: "text-foreground-info",
  neutral: "text-foreground-tertiary",
};

// Mirrors the "traffic light" a SIM/product can be in (see SimCardDetail.simStatus)
// so callers can derive a chip straight from API data instead of inventing new labels.
export const simStatusToProductCardChipTone: Record<
  SimCardDetailSimStatus,
  ProductCardChipTone
> = {
  green: "success",
  yellow: "warning",
  orange: "warning",
  red: "error",
  grey: "neutral",
};

export interface ProductCardChipProps {
  label: ReactNode;
  tone?: ProductCardChipTone;
  className?: string;
}

export const ProductCardChip = ({
  label,
  tone = "neutral",
  className,
}: ProductCardChipProps) => (
  <span
    className={clsx(
      "inline-flex h-6 shrink-0 items-center rounded-full bg-surface-quaternary px-2 py-1 text-body-xs font-semibold leading-none",
      toneClassName[tone],
      className,
    )}
  >
    {label}
  </span>
);
